require.register("app/restaurant/stat/CAView", function(exports, require, module){
  $0
  
});

